'use strict'

import _find from 'lodash/find'
import _groupBy from 'lodash/groupBy'
import _isEmpty from 'lodash/isEmpty'
import _orderBy from 'lodash/orderBy'
import _range from 'lodash/range'
import _values from 'lodash/values'
import moment from 'moment'

import { BaseView } from '../../../shared/utils/baseComponent'
import template from './documents.template.pug'

class CustomerDocumentsController extends BaseView {
  constructor($mdSidenav, $filter, $mdToast, $mdMedia, $mdMenu, $element, $mdDialog, $state, $locale) {
    'ngInject'
    super($element)
    Object.assign(
      this,
      { $mdSidenav, $filter, $mdToast, $mdMedia, $mdMenu, $mdDialog, $state, $locale },
      {
        eyeCatcher: require('../../assets/docs.svg'),
        yearRange: _range(new Date().getFullYear(), new Date().getFullYear() - 3),
        monthRange: _range(12, 0),
      },
    )
  }

  $onChanges(changes) {
    if (changes.documents) {
      this.documents = _orderBy(this.documents, ['documentDate'], ['desc'])
      this.groupedDocuments = _groupBy(this.documents, (doc) => this.$filter('date')(doc.documentDate, 'M'))
      if (_isEmpty(this.groupedDocuments)) this.groupedDocuments = null
    }
  }

  goto(year) {
    this.$state.go(this.$state.current, { year: year })
  }

  search() {
    const searchDialog = this.$mdDialog.documentSearchDialog({
      fullscreen: true,
      bindToController: true,
      locals: {
        documents: this.documents,
        year: this.$state.params.year,
        customer: this.customer,
      },
    })
    return this.$mdDialog.show(searchDialog)
  }

  monthName(number) {
    return this.$locale.DATETIME_FORMATS.MONTH[number - 1]
  }

  $onInit() {
    this.yearMax = moment().year()
    this.yearMin = moment().subtract(5, 'years').year()

    this.year = this.yearMax
    this.yearOptions = []

    this.quarter = moment().quarter()
    this.quarterOptions = []

    this.getYears()
    this.getQuarters()
    this.enrichDocuments()
  }

  enrichDocuments() {
    this.documents.forEach((doc) => {
      let taskSiteAddress = _find(this.tasksites, { code: doc.taskSiteCode })
      if (taskSiteAddress) doc.taskSiteAddress = _values(taskSiteAddress).join(' ')
      doc.documentDateText = moment(doc.documentDate).format('LLLL')
      doc.typeText = this.$filter('documentTypeFilter')(doc.type)
    })
  }

  loadDocuments() {
    const format = 'YYYY-MM-DD'
    let from, to
    if (parseInt(this.quarter) === 0) {
      from = moment(`${this.year}`).startOf('year').format(format)
      to = moment(`${this.year}`).endOf('year').format(format)
    } else {
      from = moment(`${this.year} ${this.quarter * 3}`)
        .startOf('quarter')
        .format(format)
      to = moment(`${this.year} ${this.quarter * 3}`)
        .endOf('quarter')
        .format(format)
    }
    return this.customer.getDocuments(from, to).then((documents) => {
      this.documents = documents
      this.enrichDocuments()
    })
  }

  getYears() {
    let year = this.yearMin
    while (year <= this.yearMax) {
      this.yearOptions.push(year)
      year++
    }
  }

  getQuarters() {
    if (this.year >= this.yearMax) {
      this.quarterOptions = []
      let quarter = 1
      const quarterNow = moment().quarter()
      while (quarter <= quarterNow) {
        this.quarterOptions.push(quarter)
        quarter++
      }
      if (this.quarter > this.quarterOptions.length) this.quarter = 0
    } else this.quarterOptions = [1, 2, 3, 4]
  }

  openItemMenu($mdMenu, ev) {
    $mdMenu.open(ev)
  }
}

export const customerDocumentsComponent = {
  controller: CustomerDocumentsController,
  bindings: {
    customer: '<',
    documents: '<',
    tasksites: '<',
  },
  template: template(),
}



// WEBPACK FOOTER //
// ./app/documents/containers/documents/documents.component.js